import { render, staticRenderFns } from "./supplementalMaterials.vue?vue&type=template&id=087badc8&scoped=true&"
import script from "./supplementalMaterials.vue?vue&type=script&lang=js&"
export * from "./supplementalMaterials.vue?vue&type=script&lang=js&"
import style0 from "./supplementalMaterials.vue?vue&type=style&index=0&id=087badc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087badc8",
  null
  
)

export default component.exports